<script setup lang="ts">
    import type { AiMessage, FreeLineData, CreateContactData, CreateWorksiteData } from '~/stores/aiAssistantTypes';
    import { INLINE_FORM_KIND } from '~/stores/aiAssistantTypes';

    const props = defineProps<{
        message: AiMessage;
    }>();

    const emit = defineEmits<{
        (e: 'submit-form', parentMessageId: string, formMessageId: string, payload: { freeLineData?: FreeLineData; createContactData?: CreateContactData; createWorksiteData?: CreateWorksiteData; selectedExistingUuid?: string }): void;
        (e: 'cancel-form', formMessageId: string): void;
    }>();

    const onSubmitFreeLine = (data: FreeLineData) => {
        emit('submit-form', props.message.inlineFormParentId!, props.message.id, { freeLineData: data });
    };

    const onSubmitContact = (data: CreateContactData) => {
        emit('submit-form', props.message.inlineFormParentId!, props.message.id, { createContactData: data });
    };

    const onSubmitWorksite = (data: CreateWorksiteData) => {
        emit('submit-form', props.message.inlineFormParentId!, props.message.id, { createWorksiteData: data });
    };

    const onSelectExisting = (uuid: string) => {
        emit('submit-form', props.message.inlineFormParentId!, props.message.id, { selectedExistingUuid: uuid });
    };

    const cancel = () => emit('cancel-form', props.message.id);
</script>

<template>
    <div class="flex flex-col items-start py-[8px] w-full">
        <div class="w-full max-w-[680px]">
            <AiFreeLineForm
                v-if="message.inlineFormKind === INLINE_FORM_KIND.FREE_LINE"
                :initial-title="message.inlineFormSearchTerm ?? ''"
                @submit="onSubmitFreeLine"
                @cancel="cancel"
            />
            <AiCreateContactForm
                v-else-if="message.inlineFormKind === INLINE_FORM_KIND.CREATE_CONTACT"
                :search-term="message.inlineFormSearchTerm ?? ''"
                @submit="onSubmitContact"
                @cancel="cancel"
                @select-existing="onSelectExisting"
            />
            <AiCreateWorksiteForm
                v-else-if="message.inlineFormKind === INLINE_FORM_KIND.CREATE_WORKSITE"
                :search-term="message.inlineFormSearchTerm ?? ''"
                @submit="onSubmitWorksite"
                @cancel="cancel"
                @select-existing="onSelectExisting"
            />
        </div>
    </div>
</template>
